import script from "./MProfileOther.vue?vue&type=script&setup=true&lang=js"
export * from "./MProfileOther.vue?vue&type=script&setup=true&lang=js"

import "./MProfileOther.vue?vue&type=style&index=0&id=0cae7d3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cae7d3a"]])

export default __exports__